import React, { Component } from 'react';
import ProjectsEditLayout from '../../templates/projects';
import ProjectPhasesEditForm from '../../elements/projects/phases';
import Loading from "../../elements/loading";

class ProjectPhasesEdit extends Component {
	render (){
		const {projects} = this.props;
		return (
			projects.isFetching ? <Loading message="Cargando..."/>:<ProjectPhasesEditForm {...this.props}/>
		);
	}

	componentWillMount() {
		this.props.fetchProjectPhasesGroupsEdit(this.props.match.params.id);
	}
}

export default ProjectsEditLayout(ProjectPhasesEdit, {subnav: 6});



// WEBPACK FOOTER //
// ./src/layouts/projects/phases.jsx